import type { AppLocale } from '../types'
import type { WidenStrings } from '../widenStrings'
import { enNutrimaticLabels } from './en'
import { esNutrimaticLabels } from './es'

export type NutrimaticLabels = WidenStrings<typeof esNutrimaticLabels>

const CATALOG: Record<AppLocale, NutrimaticLabels> = {
  es: esNutrimaticLabels,
  en: enNutrimaticLabels,
}

export function getNutrimaticLabels(locale: AppLocale): NutrimaticLabels {
  return CATALOG[locale]
}
